/** Dispatched after a portal AI chat turn that may have changed Builder v2 server state (see Portal::AiAssistant::Runner). */
export const PORTAL_AI_ASSISTANT_REFRESH_BUILDER_PREVIEW = "portal-ai-assistant:refresh-builder-preview"

export const PORTAL_AI_ASSISTANT_REFRESH_CALENDAR = "portal-ai-assistant:refresh-calendar"
export const PORTAL_AI_ASSISTANT_REFRESH_SERVICES = "portal-ai-assistant:refresh-services"
export const PORTAL_AI_ASSISTANT_REFRESH_CLIENTS = "portal-ai-assistant:refresh-clients"
export const PORTAL_AI_ASSISTANT_REFRESH_INTAKE_FORMS = "portal-ai-assistant:refresh-intake-forms"

/** Open the portal AI assistant FAB and optionally prefill the composer (detail.prompt). */
export const PORTAL_AI_ASSISTANT_OPEN_REQUEST = "portal-ai-assistant:open-request"

export type PortalAiRefreshSurface = "builder" | "calendar" | "services" | "clients" | "intake_forms"

const SURFACE_EVENT_NAMES: Record<PortalAiRefreshSurface, string> = {
  builder: PORTAL_AI_ASSISTANT_REFRESH_BUILDER_PREVIEW,
  calendar: PORTAL_AI_ASSISTANT_REFRESH_CALENDAR,
  services: PORTAL_AI_ASSISTANT_REFRESH_SERVICES,
  clients: PORTAL_AI_ASSISTANT_REFRESH_CLIENTS,
  intake_forms: PORTAL_AI_ASSISTANT_REFRESH_INTAKE_FORMS
}

export type PortalAiAssistantOpenRequestDetail = {
  prompt?: string
  /** When opened from Settings → Intake Forms, also sent on the chat API for updates. */
  intakeFormId?: number | string
}

/** Prefill for intake form generation from an attached PDF/DOCX (portal AI assistant). */
export const PORTAL_AI_INTAKE_FORM_GENERATION_PROMPT =
  "Generate an intake form from the document I've attached."

export function portalAiIntakeFormGenerationPrompt(intakeFormId?: number | string | null): string {
  if (intakeFormId == null || intakeFormId === "") {
    return PORTAL_AI_INTAKE_FORM_GENERATION_PROMPT
  }
  return `${PORTAL_AI_INTAKE_FORM_GENERATION_PROMPT} Update intake form id ${intakeFormId}.`
}

/** Dispatch refresh CustomEvents for surfaces not yet dispatched this turn. */
export function dispatchPortalAiRefreshSurfaces(
  surfaces: string[] | undefined,
  dispatched: Set<string>,
  options?: { refreshBuilderPreview?: boolean }
): void {
  if (typeof window === "undefined") return

  const toDispatch = new Set<string>(surfaces ?? [])
  if (options?.refreshBuilderPreview) toDispatch.add("builder")

  for (const surface of toDispatch) {
    if (dispatched.has(surface)) continue
    const eventName = SURFACE_EVENT_NAMES[surface as PortalAiRefreshSurface]
    if (!eventName) continue
    window.dispatchEvent(new CustomEvent(eventName))
    dispatched.add(surface)
  }
}
